import React, { useEffect, useState } from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import { BiCategory, BiFilterAlt } from "react-icons/bi";
import { BsFillPinMapFill, BsFillChatSquareTextFill } from "react-icons/bs";

import Cookies from "js-cookie";
import Loader from "../../component/loader";
import { decrpt } from "../../component/encryption";
import axios from "axios";

function Page() {
  const [loader, setLoader] = useState(false);
  const [dashmaster, setDashmaster] = useState();

  const fetchMatser = async () => {
    setLoader(true);
    const token = Cookies.get("s_l");
    const newToken = decrpt(token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
    await axios.get(`/admin/master/index`).then((response) => {
      setDashmaster(response.data.data);
      setLoader(false);
    });
  };

  useEffect(() => {
    fetchMatser();
  }, []);

  return (
    <div className="main-content">
      {loader ? (
        <Loader />
      ) : (
        <>
          <div className="section">
            <div className="row">
              {/* Category & Sub category */}
              <div className="col-md-12 mb-4">
                <div className="section-title">
                  <h5>
                    <BiCategory className="me-1" />
                    Category and Sub category
                  </h5>
                </div>
                <div className="count-section d-flex gap-3 mt-2">
                  <div className="count-block d-flex align-items-center justify-content-between no-divider">
                    <div className="count-figure">
                      <h3>{dashmaster && dashmaster.FirstLevelCategory}</h3>
                    </div>
                    <div className="count-content">
                      <h5>1st Level Category</h5>
                      <Link to="category" className="link-btn">
                        view
                      </Link>
                    </div>
                  </div>
                  <div className="count-block d-flex align-items-center justify-content-between no-divider">
                    <div className="count-figure">
                      <h3>{dashmaster && dashmaster.SecondLevelCategory}</h3>
                    </div>
                    <div className="count-content">
                      <h5>2nd Level Category</h5>
                      <Link to="sub_category" className="link-btn">
                        view
                      </Link>
                    </div>
                  </div>
                  <div className="count-block d-flex align-items-center justify-content-between no-divider">
                    <div className="count-figure">
                      <h3>{dashmaster && dashmaster.ThirdLevelCategory}</h3>
                    </div>
                    <div className="count-content">
                      <h5>3rd Level Category</h5>
                      <Link to="last_category" className="link-btn">
                        view
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* Filters */}
              <div className="col-md-12 mb-4">
                <div className="section-title">
                  <h5>
                    <BiFilterAlt className="me-1" />
                    Filters
                  </h5>
                </div>
                <div className="count-section d-flex gap-3 mt-2">
                  <div className="count-block d-flex align-items-center justify-content-between no-divider">
                    <div className="count-figure">
                      <h3>{dashmaster && dashmaster.Brand}</h3>
                    </div>
                    <div className="count-content">
                      <h5>Brand Filter</h5>
                      <Link to="brands" className="link-btn">
                        view
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* Address Master */}
              <div className="col-md-12">
                <div className="section-title">
                  <h5>
                    <BsFillPinMapFill className="me-1" />
                    Address Master
                  </h5>
                </div>
                <div className="mt-4">
                  <div className="count-section d-flex gap-3">
                    <div className="count-block d-flex align-items-center justify-content-between no-divider">
                      <div className="count-figure">
                        <h3>{dashmaster && dashmaster.State}</h3>
                      </div>
                      <div className="count-content">
                        <h5>State List</h5>
                        <Link to="state" className="link-btn">
                          view
                        </Link>
                      </div>
                    </div>
                    <div className="count-block d-flex align-items-center justify-content-between no-divider">
                      <div className="count-figure">
                        <h3>{dashmaster && dashmaster.District}</h3>
                      </div>
                      <div className="count-content">
                        <h5>District List</h5>
                        <Link to="district" className="link-btn">
                          view
                        </Link>
                      </div>
                    </div>
                    <div className="count-block d-flex align-items-center justify-content-between no-divider">
                      <div className="count-figure">
                        <h3>{dashmaster && dashmaster.City}</h3>
                      </div>
                      <div className="count-content">
                        <h5>City List</h5>
                        <Link to="city" className="link-btn">
                          view
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Policy Master */}
              <div className="col-md-12">
                <div className="section-title">
                  <h5>
                    <BsFillChatSquareTextFill className="me-1" />
                    Policy Master
                  </h5>
                </div>
                <div className="mt-4">
                  <div className="count-section d-flex gap-3">
                    <div className="count-block d-flex align-items-center justify-content-between no-divider">
                      <div className="count-figure">
                        <h3>{dashmaster && dashmaster.returnPolicy}</h3>
                      </div>
                      <div className="count-content">
                        <h5>Return Policy</h5>
                        <Link to="return_policy" className="link-btn">
                          view
                        </Link>
                      </div>
                    </div>
                    <div className="count-block d-flex align-items-center justify-content-between no-divider">
                      <div className="count-figure">
                        <h3>{dashmaster && dashmaster.orderCancelPolicy}</h3>
                      </div>
                      <div className="count-content">
                        <h5>Cancellation Policy</h5>
                        <Link to="cancel_policy" className="link-btn">
                          view
                        </Link>
                      </div>
                    </div>
                    <div className="count-block d-flex align-items-center justify-content-between no-divider">
                      <div className="count-figure">
                        <h3>{dashmaster && (dashmaster.returnReason ?? dashmaster.returnReasons ?? 0)}</h3>
                      </div>
                      <div className="count-content">
                        <h5>Return Reasons</h5>
                        <Link to="return_reasons" className="link-btn">
                          view
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Page;
